export enum EventDetailRoutingEnum {
  candidate = 'candidate',
  jobs = 'jobs',
  link = 'link',
  dashboard = 'dashboard',
  parameters = 'parameters',
}
